import React from 'react';
import { motion } from 'framer-motion';
interface BonusCardProps {
  number: number;
  title: string;
  description: string;
  imageUrl: string;
  delay?: number;
}
export function BonusCard({
  number,
  title,
  description,
  imageUrl,
  delay = 0
}: BonusCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.4,
    delay
  }} className="bg-white rounded-xl overflow-hidden shadow-md border border-orange-100 flex flex-row h-full" data-id="element-2">
      <div className="w-1/3 sm:w-2/5 relative overflow-hidden bg-orange-50 flex-shrink-0" data-id="element-3">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover object-center" data-id="element-4" />
        <div className="absolute top-2 left-2 bg-yellow-400 text-yellow-900 font-bold px-2 py-0.5 rounded-full text-[10px] sm:text-xs shadow-sm" data-id="element-5">
          BONUS #{number}
        </div>
      </div>
      <div className="p-3 sm:p-4 md:p-5 flex-1 flex flex-col justify-center min-w-0" data-id="element-6">
        <h3 className="text-sm sm:text-base md:text-lg font-bold text-slate-800 mb-1 sm:mb-2 leading-tight" data-id="element-7">
          {title}
        </h3>
        <p className="text-slate-600 text-xs sm:text-sm leading-snug line-clamp-3 sm:line-clamp-none" data-id="element-8">
          {description}
        </p>
      </div>
    </motion.div>;
}